import { combineReducers } from 'redux';

import {
  SET_AGENCIES_GRID_SORT_CRITERIA,
  SET_CURRENT_SELECTED_AGENCY,
  SET_AGENCIES_FILTERS,
  RESET_AGENCIES_FILTERS,
  SET_CREDENTIALS_GRID_SORT_CRITERIA,
  SET_PROFILE_FORM_IS_EDITABLE,
  SET_PROFILE_FORM_IS_NOT_EDITABLE,
  SET_PROFILE_FORM_IS_LOADING,
  SET_PROFILE_FORM_IS_NOT_LOADING,
  SAVE_AGENCIES_LIST,
  SET_AGENCIES_LIST_IS_LOADING,
  SET_AGENCIES_LIST_IS_NOT_LOADING,
  SAVE_AGENCY_CREDENTIALS,
  SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING,
  SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING,
  SET_CURRENT_SELECTED_CREDENTIAL,
  SET_SHOW_CREDENTIAL_FORM,
  SET_HIDE_CREDENTIAL_FORM,
  SET_CREDENTIAL_FORM_UPDATE_MODE,
  SET_CREDENTIAL_FORM_CREATE_MODE,
  SET_CREDENTIAL_FORM_IS_LOADING,
  SET_CREDENTIAL_FORM_IS_NOT_LOADING,
} from './actionTypes';

const agenciesGridSortCriteriaInitialState = {
  sortByColumn: 'aggregatorID',
  sortDirection: 'up',
};

const credentialsGridSortCriteriaInitialState = {
  sortByColumn: 'node',
  sortDirection: 'up',
};

const agenciesFiltersInitialState = {
  partnerID: 'ALL',
  active: true,
};

const agenciesListInitialState = {
  list: [],
  currentSelectedAgencyId: '',
  isLoading: true,
};

const credentialsListInitialState = {
  list: [],
  currentSelectedCredentialId: '',
  isLoading: true,
};

const credentialFormInitialState = {
  show: false,
  formMode: 'create',
  isLoading: true,
};

const profileFormInitialState = {
  isEditable: false,
  isLoading: false,
};

const credentialFormReducer = (state = credentialFormInitialState, action = {}) => {
  switch (action.type) {
    case SET_CREDENTIAL_FORM_UPDATE_MODE:
      return {
        ...state,
        formMode: 'update',
      };

    case SET_CREDENTIAL_FORM_CREATE_MODE:
      return {
        ...state,
        formMode: 'create',
      };

    case SET_SHOW_CREDENTIAL_FORM:
      return {
        ...state,
        show: true,
      };

    case SET_HIDE_CREDENTIAL_FORM:
      return {
        ...state,
        show: false,
      };

    case SET_CREDENTIAL_FORM_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case SET_CREDENTIAL_FORM_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

const profileFormReducer = (state = profileFormInitialState, action = {}) => {
  switch (action.type) {
    case SET_PROFILE_FORM_IS_EDITABLE:
      return {
        ...state,
        isEditable: true,
      };

    case SET_PROFILE_FORM_IS_NOT_EDITABLE:
      return {
        ...state,
        isEditable: false,
      };

    case SET_PROFILE_FORM_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case SET_PROFILE_FORM_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
};

const currentAgenciesGridSortCriteriaReducer = (
  state = agenciesGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...agenciesGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_AGENCIES_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const currentCredentialsGridSortCriteriaReducer = (
  state = credentialsGridSortCriteriaInitialState,
  { type = '', sortCriteria = { ...credentialsGridSortCriteriaInitialState } } = {},
) => {
  switch (type) {
    case SET_CREDENTIALS_GRID_SORT_CRITERIA:
      return {
        ...state,
        ...sortCriteria,
      };

    default:
      return state;
  }
};

const agenciesFiltersReducer = (
  state = agenciesFiltersInitialState,
  { type = '', filters = { ...agenciesFiltersInitialState } } = {},
) => {
  switch (type) {
    case SET_AGENCIES_FILTERS:
      return {
        ...state,
        ...filters,
      };

    case RESET_AGENCIES_FILTERS:
      return {
        ...state,
        ...agenciesFiltersInitialState,
      };

    default: {
      return state;
    }
  }
};

const agenciesListReducer = (state = agenciesListInitialState, action = {}) => {
  switch (action.type) {
    case SAVE_AGENCIES_LIST:
      return {
        ...state,
        ...action.agencies,
      };

    case SET_CURRENT_SELECTED_AGENCY:
      return {
        ...state,
        currentSelectedAgencyId: action.currentSelectedAgencyId,
      };

    case SET_AGENCIES_LIST_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case SET_AGENCIES_LIST_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    default: {
      return state;
    }
  }
};

const credentialsListReducer = (state = credentialsListInitialState, action = {}) => {
  switch (action.type) {
    case SAVE_AGENCY_CREDENTIALS:
      return {
        ...state,
        ...action.credentials,
      };

    case SET_CURRENT_SELECTED_CREDENTIAL:
      return {
        ...state,
        currentSelectedCredentialId: action.currentSelectedCredentialId,
      };

    case SET_AGENCIES_CREDENTIALS_LIST_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case SET_AGENCIES_CREDENTIALS_LIST_IS_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    default: {
      return state;
    }
  }
};

const agenciesReducer = combineReducers({
  agenciesGridSortCriteria: currentAgenciesGridSortCriteriaReducer,
  credentialsGridSortCriteria: currentCredentialsGridSortCriteriaReducer,
  agenciesFilters: agenciesFiltersReducer,
  profileForm: profileFormReducer,
  agenciesList: agenciesListReducer,
  credentialsList: credentialsListReducer,
  credentialForm: credentialFormReducer,
});

export {
  agenciesReducer,
  agenciesGridSortCriteriaInitialState,
  agenciesFiltersInitialState,
  credentialsGridSortCriteriaInitialState,
  profileFormInitialState,
  agenciesListInitialState,
  credentialsListInitialState,
  credentialFormInitialState,
};
